/**
 * Entorno del frontend. `npm start` define NODE_ENV=development y el build,
 * production.
 *
 * En desarrollo, lo que escribe en servicios sin equivalente local (correos,
 * archivos, Gestor de Pagos, SDA) sólo funciona si su URL se configuró
 * explícitamente con una variable REACT_APP_, por ejemplo en
 * .env.development.local. Así un `npm start` no toca producción por accidente.
 */
export const ES_DESARROLLO = process.env.NODE_ENV === 'development';

/**
 * En desarrollo, exige que la variable esté definida antes de una escritura
 * externa. En producción no hace nada.
 * @param {string|undefined} valor valor de la variable (process.env.REACT_APP_...)
 * @param {string} variable nombre de la variable, para el mensaje
 * @param {string} accion lo que se intentaba hacer
 */
export function exigirConfiguradoEnDesarrollo(valor, variable, accion) {
  if (ES_DESARROLLO && !valor) {
    const mensaje = `[development] ${accion}: no se ejecuta porque ${variable} no está definida. Configúrala en .env.development.local con un servicio de desarrollo.`;
    console.warn(mensaje);
    throw new Error(mensaje);
  }
}
